(function ($) {
  Drupal.behaviors.ehThewinkHpRedesignTopStoriesFormatterV1 = {
    attach: function (context, settings) {
      var formatter = $('.eh-thewink-hp-redesign-top-stories-formatter-v1', context);

      formatter.each(function () {
        var thisFormatter = $(this);

        // Makes the top stories two columns only for PC and tablets
        // if (!site.client.isMobile) {
        // Some Android tablets returs 1 (true) to "site.client.isMobile" while having the "device-pc" body class
        if (!site.client.isMobile && !$('body').hasClass('device-mobile') ||
           ($('body').hasClass('device-pc') && $(window).width() <= 1280 && $('body').hasClass('device-pc') && !$('body').hasClass('device-mobile') && $(window).height() <= 800) ||
           ($('body').hasClass('device-pc') && $(window).width() <= 800 && $('body').hasClass('device-pc') && !$('body').hasClass('device-mobile') && $(window).height() <= 1280)) {
          createTwoCols(thisFormatter, 'container-inner', 'left-col', 'left-col-parent', 'right-col', 'right-col-parent');
        }
      });
    }
  };

  // Wrap cols in left/right containers
  createTwoCols = function (selector, contInner, leftCol, leftColParentClass, rightCol, rightColParentClass) {
    var $contInner = selector.find('.' + contInner); // container-inner
    // Left column
    var $leftCol = $contInner.find('.' + leftCol); // left-col

    $leftCol.parent().addClass(leftColParentClass); // left-col-parent
    var $leftColParent = selector.find('.' + contInner + '.' + leftColParentClass); // container-inner left-col-parent

    $leftColParent.wrapAll('<div class="left-col-container"></div>');
    // Right column
    var $rightCol = $contInner.find('.' + rightCol); // right-col

    $rightCol.parent().addClass(rightColParentClass); // right-col-parent
    var $rightColParent = selector.find('.' + contInner + '.' + rightColParentClass); // container-inner right-col-parent

    $rightColParent.wrapAll('<div class="right-col-container"></div>');
  };
})(jQuery);
